import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FmlxModal, FmlxRadioButton} from 'fmlx-common-ui';
import {useIntl} from 'react-intl';
import FormattedHTMLMessage from 'components/FormattedHTMLMessage';
import './CSVImportPlateColumnPreferenceModal.scss';
import {CSVImportPlateColumnPreference} from 'constants/dataEnum';

function CSVImportPlateColumnPreferenceModal(props) {
  const {onCloseModal, onConfirmPlatePreference} = props;
  const intl = useIntl();
  const [selectedPrefIndex, setSelectedPrefIndex] = useState(-1);

  const optionItems = [
    {
      value: CSVImportPlateColumnPreference.PLATE_NAME,
      content: intl.formatMessage({id: 'modal.csvImportPlatePreference.option.plateName'}),
    },
    {
      value: CSVImportPlateColumnPreference.PLATE_BARCODE,
      content: intl.formatMessage({id: 'modal.csvImportPlatePreference.option.plateBarcode'}),
      type: 'information',
      hint: intl.formatMessage({id: 'modal.csvImportPlatePreference.optionInfo.plateBarcode'}),
    },
  ];

  const handleRadioChange = (value) => {
    const {index} = value;
    setSelectedPrefIndex(index);
  };

  const handleConfirmClick = () => {
    onConfirmPlatePreference(optionItems[selectedPrefIndex].value);
  };

  return (
    <FmlxModal
      open
      size="md"
      title={intl.formatMessage({id: 'modal.csvImportPlatePreference.title'})}
      onCloseClick={onCloseModal}
      tertiaryButton={{show: false}}
      primaryButton={{
        label: intl.formatMessage({id: 'modal.csvImportPlatePreference.button.confirm'}),
        disabled: selectedPrefIndex === -1,
        show: true,
        type: 'primary',
        variant: 'contain',
        onClick: handleConfirmClick,
      }}
      secondaryButton={{
        label: intl.formatMessage({id: 'modal.csvImportPlatePreference.button.cancel'}),
        disabled: false,
        show: true,
        type: 'basic',
        variant: 'outline',
        onClick: onCloseModal,
      }}
    >
      <div className="csv-import-plate-column-preference-content">
        <div className="csv-import-plate-column-preference-content__section">
          <FormattedHTMLMessage id="modal.csvImportPlatePreference.optionsMessage" />
        </div>
        <div className="csv-import-plate-column-preference-content__section">
          <FmlxRadioButton items={optionItems} onChange={handleRadioChange} selectedIndex={selectedPrefIndex} />
        </div>
      </div>
    </FmlxModal>
  );
}

CSVImportPlateColumnPreferenceModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onConfirmPlatePreference: PropTypes.func.isRequired,
};

export default CSVImportPlateColumnPreferenceModal;
